import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faSquarePlus } from '@fortawesome/pro-light-svg-icons';

export type ProLightSquarePlusProps = IconComponentProps;

export const ProLightSquarePlus = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightSquarePlusProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faSquarePlus}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faSquarePlus}
    />
  );
};

ProLightSquarePlus.displayName = 'ProLightSquarePlus';
